<template>
	<div class="layer-project" data-project-name="lgchem-life-science">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="award14"></span>LG Chem <br class="blank mb" />Life
						Sciences Company
					</h1>
					<a href="http://bio.lgchem.com" class="link" target="_blank"
						>bio.lgchem.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						LG화학으로 합병된 (舊) LG생명과학 제품 사이트로, 국내 최고의 화학
						기업인 LG화학의 생명과학 사업본부의 제품을 소개하는 사이트입니다.
						<br class="blank pc" />의약/백신/파인케미컬 등의 제품군을 소개하고
						제품 촬영을 통해 LG화학의 브랜드 아이덴티티를 유지, 전달할 수 있도록
						제작했습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">LG Chem</li>
						</ul>
						<ul class="diagram02">
							<li class="item02">Pharmaceuticals</li>
							<li class="item03">Vaccine</li>
							<li class="item04">Fine Chemical</li>
						</ul>
						<ul class="diagram03">
							<li class="item05">LG Chem<br />Life Sciences<br />Company</li>
						</ul>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section section01">
				<div class="inner-section">
					<div class="detail-img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lgchem-life-science/sec1-cont@t.png"
							data-exception="mobile"
						/>
					</div>
				</div>
			</section>
			<section class="section section02 full">
				<div class="inner-section">
					<div class="cont-tit-area max-limit">
						<strong class="project-subtit">PC Web</strong>
						<p class="cont-desc">
							사업 군 별 이미지를 Full Screen으로 배치하여 각 사업영역에 대한
							강조 및 집중도를 높일 수 있도록 구성했습니다. <br />비주얼 위에는
							크게 3가지 분야의 페이지로 이동이 가능하도록 메뉴를 배치하고
							마우스 오버 시 배경 이미지가 변경되는 인터렉션으로 시각적인 효과를
							극대화했습니다.
						</p>
					</div>
					<div class="detail-img">
						<div class="content cont01 mobile-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgchem-life-science/sec2-cont01-img01@m.png"
									/>
								</div>
								<div class="swiper-slide">
									<p class="slide-tit">
										<img
											src=""
											alt=""
											data-src="/static/img/project-detail/lgchem-life-science/sec2-cont01-tit02@mt.png"
											data-break="mt-w"
										/>
									</p>
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgchem-life-science/sec2-cont01-img02@m.png"
									/>
								</div>
								<div class="swiper-slide">
									<p class="slide-tit">
										<img
											src=""
											alt=""
											data-src="/static/img/project-detail/lgchem-life-science/sec2-cont01-tit03@t.png"
											data-break="mt-w"
										/>
									</p>
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgchem-life-science/sec2-cont01-img03@m.png"
									/>
								</div>
								<div class="swiper-slide">
									<p class="slide-tit">
										<img
											src=""
											alt=""
											data-src="/static/img/project-detail/lgchem-life-science/sec2-cont01-tit04@mt.png"
											data-break="mt-w"
										/>
									</p>
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/lgchem-life-science/sec2-cont01-img04@m.png"
									/>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
						<div class="content cont02">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-life-science/sec2-cont02@m.png"
							/>
						</div>
						<div class="content cont03">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-life-science/sec2-cont03@m.jpg"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section section03 full">
				<div class="inner-section">
					<div class="cont-tit-area max-limit">
						<strong class="project-subtit">Mobile Web</strong>
						<p class="cont-desc">
							의약/백신/파인케미컬 등의 주요 제품군을
							<br class="blank mb" />1<sup>st</sup> Depth로 배치하여 정보
							접근성을 강조했습니다. <br />LG화학의 생명공학 사업분야를 분리하여
							좀 더 전문적인 내용으로 구성하였고, 사업분야에 맞는 이미지를
							<br class="blank tb" />구축했습니다.
						</p>
					</div>
					<div class="detail-img">
						<div class="content cont01">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-life-science/sec3-cont01@m.png"
							/>
						</div>
						<div class="content cont02">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-life-science/sec3-cont02@m.jpg"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section section04">
				<div class="inner-section">
					<dl class="detail-cont text">
						<dt class="cont-subtit">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-life-science/sec4-tit@m.png"
							/>
						</dt>
						<dd class="cont-desc">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-life-science/sec4-desc@m.png"
							/>
						</dd>
					</dl>
					<dl class="detail-cont color">
						<dt>
							웹사이트의 기본 색상은 LG화학의 브랜드 아이덴티티 컬러인
							<br class="blank tb" />Gray를, <br class="blank pc" />강조
							색상으로는 Red 컬러를 적용하였습니다.
						</dt>
						<dd>
							<span data-color="#333333">#333333</span>
							<span data-color="#555555">#555555</span>
							<span data-color="#b41131">#b41131</span>
						</dd>
					</dl>
					<dl class="detail-cont icon">
						<dt>
							생명과학의 브랜드 아이덴티티를 살린 간단하고 명료한<br />아이콘을
							사용하여 LG생명과학의 이미지를 구축하였습니다.
						</dt>
						<dd>
							<span
								><img
									src="/static/img/project-detail/lgchem-life-science/sec4-icon01.png"
							/></span>
							<span
								><img
									src="/static/img/project-detail/lgchem-life-science/sec4-icon02.png"
							/></span>
							<span
								><img
									src="/static/img/project-detail/lgchem-life-science/sec4-icon03.png"
							/></span>
							<span
								><img
									src="/static/img/project-detail/lgchem-life-science/sec4-icon04.png"
							/></span>
						</dd>
					</dl>
				</div>
			</section>

			<section class="project-client">
				<strong class="a11y-hidden">LG Chem Life Sciences Company</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".mobile-swiper", {
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $(this).outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
div[class^="rwd"] {
	display: none;
}
.layer-project-detail > section.full {
	padding-bottom: 0;
}
.project-subtit {
	margin-bottom: 10px;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
.section .cont-tit-area {
	word-break: keep-all;
}
.section .detail-img {
	text-align: center;
}
@media screen and (max-width: 711px) {
	div[class="rwd-mb"] {
		display: inline-block;
	}
	.section.full .max-limit {
		padding: 0 15px;
	}
	.blank.mb {
		display: block;
	}
	.blank.tb,
	.blank.pc {
		display: none;
	}
}
@media screen and (min-width: 712px) {
	div[class="rwd-tb"] {
		display: inline-block;
	}
	.section.full .max-limit {
		padding: 0 40px;
	}
	.blank.tb {
		display: block;
	}
	.blank.mb,
	.blank.pc {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	div[class="rwd-tb"] {
		display: none;
	}
	div[class="rwd-pc"] {
		display: inline-block;
	}
	.section.full {
		max-width: 1920px;
	}
	.section.full .max-limit {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.blank.pc {
		display: block;
	}
	.blank.mb,
	.blank.tb {
		display: none;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/lgchem-life-science/ci.png) 50% /
		auto 47.5px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem-life-science/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem-life-science/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 59px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem-life-science/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 118px;
	}
}

/* Overview */
.project-overview {
	background-color: #fff;
	color: #222;
}
.project-overview-diagram {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
}
.project-overview-diagram ul {
	position: relative;
}
.project-overview-diagram ul li {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	line-height: 1.2;
	border-radius: 50%;
}
.project-overview-diagram .diagram01 li {
	background-color: #b8052d;
}
.project-overview-diagram .diagram02 {
	display: flex;
	border: 1px solid #e5e5e5;
}
.project-overview-diagram .diagram02 li {
	background-color: #eee;
}
.project-overview-diagram .diagram03 li {
	background-color: #333;
}
.project-overview-diagram ul:not(.diagram02) li {
	color: #fff;
}
.project-overview-diagram ul:not(.diagram03)::after {
	transform: rotate(45deg);
}
.project-overview-diagram ul:not(.diagram03)::before,
.project-overview-diagram ul:not(.diagram03)::after {
	position: absolute;
	content: "";
	display: block;
	background-color: #bbb;
}
@media screen and (max-width: 711px) {
	.project-overview-diagram {
		flex-direction: column;
	}
	.project-overview-diagram ul {
		margin: 20px 0;
	}
	.project-overview-diagram ul:not(.diagram02) li {
		width: 105px;
		height: 105px;
		font-size: 14px;
	}
	.project-overview-diagram .diagram02 {
		padding: 12px 10px;
		border-radius: 105px;
	}
	.project-overview-diagram .diagram02 li {
		width: 105px;
		height: 105px;
		font-size: 12px;
	}
	.project-overview-diagram .diagram02 .item03 {
		margin: 0 -7px;
	}
	.project-overview-diagram ul:not(.diagram03)::before {
		width: 1px;
		height: 25px;
		left: 50%;
		bottom: -25px;
	}
	.project-overview-diagram ul:not(.diagram03)::after {
		width: 1px;
		height: 8px;
		left: calc(50% + 4px);
		bottom: -25px;
	}
	.project-overview-diagram .diagram02 li:not(.item04)::before,
	.project-overview-diagram .diagram02 li:not(.item04)::after {
		display: none;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		padding: 30px 0;
	}
	.project-overview-diagram ul {
		margin: 0 22px;
	}
	.project-overview-diagram ul:not(.diagram02) li {
		width: 100px;
		height: 100px;
	}
	.project-overview-diagram .diagram02 {
		padding: 10px 14px;
		border-radius: 90px;
	}
	.project-overview-diagram .diagram02 li {
		position: relative;
		width: 90px;
		height: 90px;
		font-size: 12px;
	}
	.project-overview-diagram .diagram02 li:not(.item04)::before,
	.project-overview-diagram .diagram02 li:not(.item04)::after {
		position: absolute;
		top: 50%;
		right: -17px;
		content: "";
		display: block;
		width: 9px;
		height: 1px;
		background-color: #bbb;
	}
	.project-overview-diagram .diagram02 li:not(.item04)::after {
		transform: rotate(90deg);
	}
	.project-overview-diagram .diagram02 .item03 {
		margin: 0 25px;
	}
	.project-overview-diagram ul:not(.diagram03)::before {
		width: 25px;
		height: 1px;
		top: 50%;
		right: -25px;
	}
	.project-overview-diagram ul:not(.diagram03)::after {
		width: 8px;
		height: 1px;
		top: calc(50% - 4px);
		right: -25px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-diagram {
		padding: 70px 0;
	}
	.project-overview-diagram ul {
		margin: 0 47px;
	}
	.project-overview-diagram ul li {
		line-height: 1.5;
	}
	.project-overview-diagram ul:not(.diagram02) li {
		width: 200px;
		height: 200px;
	}
	.project-overview-diagram .diagram01 li {
		font-size: 24px;
	}
	.project-overview-diagram .diagram02 {
		padding: 17px 34px;
		border-width: 2px;
		border-radius: 160px;
	}
	.project-overview-diagram .diagram02 li {
		position: relative;
		width: 158px;
		height: 158px;
		font-size: 16px;
	}
	.project-overview-diagram .diagram02 li:not(.item04)::before,
	.project-overview-diagram .diagram02 li:not(.item04)::after {
		position: absolute;
		top: 50%;
		right: -35px;
		content: "";
		display: block;
		width: 17px;
		height: 1px;
		background-color: #bbb;
	}
	.project-overview-diagram .diagram02 li:not(.item04)::after {
		transform: rotate(90deg);
	}
	.project-overview-diagram .diagram02 .item03 {
		margin: 0 53px;
	}
	.project-overview-diagram .diagram03 li {
		font-size: 20px;
	}
	.project-overview-diagram ul:not(.diagram03)::before {
		width: 75px;
		height: 1px;
		top: 50%;
		right: -75px;
	}
	.project-overview-diagram ul:not(.diagram03)::after {
		width: 16px;
		height: 1px;
		top: calc(50% - 6px);
		right: -77px;
	}
}

/* section01 */
.section01 {
	background-color: #444;
}
@media screen and (max-width: 711px) {
	.section01 {
		display: none;
	}
}

/* section02 */
.section02 {
	position: relative;
}
.section02 {
	background-color: #eee;
}
@media screen and (max-width: 711px) {
	.section02 .mobile-swiper {
		position: relative;
		margin: 15px 0 30px;
		padding-bottom: 20px;
	}
	.section02 .cont01 .swiper-slide img {
		width: 97.81vw;
	}
	.section02 .cont01 .swiper-slide .slide-tit {
		display: none;
	}
}
@media screen and (min-width: 712px) {
	.section02 .mobile-swiper {
		margin: 30px 0;
	}
	.section02 .cont01 .swiper-wrapper {
		flex-direction: column;
		align-items: center;
		margin: 30px 0;
	}
	.section02 .cont01 .swiper-slide {
		width: 94.1vw;
	}
	.section02 .cont01 .swiper-slide .slide-tit {
		width: 100%;
		padding: 15px 40px 0;
		text-align: right;
	}
	.section02 .cont01 .swiper-slide .slide-tit img {
		width: auto;
		height: 10px;
	}
	.section02 .cont02 img {
		position: relative;
		width: 93.82vw;
		left: -25px;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .cont-desc {
		line-height: 1.8;
	}
	.section02 .cont01 .swiper-slide {
		width: auto;
	}
	.section02 .cont01 .swiper-slide img {
		position: relative;
		left: 20px;
	}
	.section02 .cont01 .swiper-slide .slide-tit {
		width: 100%;
		padding: 0 70px 10px;
		text-align: right;
	}
	.section02 .cont01 .swiper-slide .slide-tit img {
		height: auto;
	}
	.section02 .cont02 {
		margin-top: 120px;
	}
	.section02 .cont02 img {
		position: relative;
		width: auto;
	}
}

/* section03 */
.section03 {
	background-color: #f9f9f9;
}
.section03 .cont01 {
	overflow-y: hidden;
}
@media screen and (max-width: 711px) {
	.section03 .cont-tit-area {
		margin-bottom: 20px;
	}
	.section03 .cont01 {
		max-height: 196.71vw;
	}
}
@media screen and (min-width: 712px) {
	.section03 .cont01 {
		max-height: 79.8vw;
		padding: 0 40px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .inner-section {
		padding-top: 60px;
	}
	.section03 .cont-tit-area {
		padding: 60px 0;
	}
	.section03 .cont-desc {
		line-height: 1.8;
	}
	.section03 .cont01 {
		max-height: 1180px;
	}
}

/* section04 */
.section04 {
	background-color: #f2f2f2;
}
.section04 dt {
	font-weight: 500;
}
.section04 .color dd {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.section04 .color dd span {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	color: #fff;
	font-weight: 400;
	letter-spacing: 0.5px;
	box-shadow: 9px 15px 29px 0px rgba(0, 0, 0, 0.22);
}
.section04 .color dd span[data-color="#333333"] {
	background-color: #333333;
}
.section04 .color dd span[data-color="#555555"] {
	background-color: #555555;
}
.section04 .color dd span[data-color="#b41131"] {
	background-color: #b41131;
}
.section04 .icon dd {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
@media screen and (max-width: 711px) {
	.section04 .inner-section {
		padding-top: 20px;
	}
	.section04 .detail-cont {
		font-size: 12px;
	}
	.section04 .text {
		margin-bottom: 40px;
	}
	.section04 .text dt img {
		width: 87.34vw;
	}
	.section04 .text dd {
		margin-top: 19px;
	}
	.section04 .text dd img {
		width: 78.75vw;
	}
	.section04 .color {
		margin-bottom: 50px;
	}
	.section04 .color dd {
		margin-top: 18px;
	}
	.section04 .color dd span {
		width: 80px;
		height: 80px;
		font-size: 12px;
	}
	.section04 .icon dd {
		margin-top: 20px;
	}
	.section04 .icon dd span {
		width: 8.59375vw;
	}
}
@media screen and (min-width: 712px) {
	.section04 .inner-section {
		padding-top: 40px;
		padding-bottom: 40px;
	}
	.section04 .detail-cont {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
	}
	.section04 .detail-cont dt,
	.section04 .detail-cont dd {
		width: 41vw;
	}
	.section04 .text {
		margin-bottom: 38px;
	}
	.section04 .text dt img {
		width: 32.86vw;
	}
	.section04 .text dd img {
		width: 35.39vw;
	}
	.section04 .color {
		margin-bottom: 60px;
	}
	.section04 .color dd {
		padding-right: 21px;
	}
	.section04 .color dd span {
		width: 71px;
		height: 71px;
		font-size: 11px;
	}
	.section04 .icon dd {
		padding: 0 20px;
	}
	.section04 .icon dd span {
		width: 22px;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .inner-section {
		padding: 110px 20px 80px;
	}
	.section04 .detail-cont {
		margin: 0;
		padding: 40px 0;
		font-size: 16px;
	}
	.section04 .detail-cont dt,
	.section04 .detail-cont dd {
		width: 620px;
	}
	.section04 .text dt img,
	.section04 .text dd img {
		width: auto;
	}
	.section04 .color dd {
		min-width: 520px;
		padding-right: 80px;
	}
	.section04 .color dd span {
		width: 142px;
		height: 142px;
		font-size: 14px;
	}
	.section04 .icon dd {
		min-width: 520px;
		padding-left: 35px;
		padding-right: 110px;
	}
	.section04 .icon dd span {
		width: 43px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/lgchem-life-science.vue